/**
 * School procurement main categories + subcategory SKU rows (images & indicative prices).
 * Single source for Marketing page and Estore “School essentials” strip.
 */

export const marketingNavCategories = [
  "Classroom Essentials",
  "Office & Administration Items",
  "Digital Infrastructure",
  "Library Items",
  "Science Lab Items",
  "Sports Equipment",
  "Safety & Compliance",
];

export const classroomProducts = {
  "Benches & desks": [
    { img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b", price: "₹3,500" },
    { img: "https://images.unsplash.com/photo-1596495578065-6e0763fa1178", price: "₹4,200" },
    { img: "https://images.unsplash.com/photo-1577896851231-70ef18881754", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36", price: "₹3,800" },
  ],
  "Teacher table & chair": [
    { img: "https://images.unsplash.com/photo-1549497538-303791108f95", price: "₹2,800" },
    { img: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4", price: "₹4,500" },
    { img: "https://images.unsplash.com/photo-1501045661006-fcebe0257c3f", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4", price: "₹5,200" },
  ],
  "Whiteboard / Green board": [
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹1,900" },
    { img: "https://images.unsplash.com/photo-1600054800747-652c3a2a6e0f", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1600054800747-652c3a2a6e0f", price: "₹2,200" },
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹2,000" },
  ],
  "Projector or LED TV (optional)": [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹35,000" },
    { img: "https://images.unsplash.com/photo-1593784991095-a205069470b6", price: "₹28,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹42,000" },
    { img: "https://images.unsplash.com/photo-1593784991095-a205069470b6", price: "₹31,000" },
  ],
  "Chalk / Markers": [
    { img: "https://images.unsplash.com/photo-1610465299993-e6675c9f9c88", price: "₹120" },
    { img: "https://images.unsplash.com/photo-1610465299993-e6675c9f9c88", price: "₹150" },
    { img: "https://images.unsplash.com/photo-1610465299993-e6675c9f9c88", price: "₹180" },
    { img: "https://images.unsplash.com/photo-1610465299993-e6675c9f9c88", price: "₹200" },
  ],
  "Bulletin board": [
    { img: "https://images.unsplash.com/photo-1591981012104-3a0f1f95c8c7", price: "₹2,100" },
    { img: "https://images.unsplash.com/photo-1591981012104-3a0f1f95c8c7", price: "₹2,400" },
    { img: "https://images.unsplash.com/photo-1591981012104-3a0f1f95c8c7", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1591981012104-3a0f1f95c8c7", price: "₹2,600" },
  ],
  "Fans / AC": [
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹38,000" },
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹42,000" },
  ],
  "Classroom almirah / storage": [
    { img: "https://images.unsplash.com/photo-1616627986631-21a87e7d90c2", price: "₹9,500" },
    { img: "https://images.unsplash.com/photo-1616627986631-21a87e7d90c2", price: "₹11,000" },
    { img: "https://images.unsplash.com/photo-1616627986631-21a87e7d90c2", price: "₹8,800" },
    { img: "https://images.unsplash.com/photo-1616627986631-21a87e7d90c2", price: "₹10,200" },
  ],
  "Dustbin": [
    { img: "https://images.unsplash.com/photo-1581574207423-14bb7cfa8b9b", price: "₹350" },
    { img: "https://images.unsplash.com/photo-1581574207423-14bb7cfa8b9b", price: "₹420" },
    { img: "https://images.unsplash.com/photo-1581574207423-14bb7cfa8b9b", price: "₹390" },
    { img: "https://images.unsplash.com/photo-1581574207423-14bb7cfa8b9b", price: "₹450" },
  ],
  "Attendance registers / timetable": [
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹180" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹220" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹200" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹250" },
  ],
  "Shape": [
    { img: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b", price: "₹600" },
    { img: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b", price: "₹750" },
    { img: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b", price: "₹900" },
    { img: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b", price: "₹1,100" },
  ],
};

export const officeAdminProducts = {
  "Office tables & chairs": [
    { img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7", price: "₹6,500" },
    { img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36", price: "₹8,200" },
    { img: "https://images.unsplash.com/photo-1549497538-303791108f95", price: "₹7,800" },
    { img: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4", price: "₹9,000" },
  ],
  "Computers / laptops": [
    { img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8", price: "₹42,000" },
    { img: "https://images.unsplash.com/photo-1518770660439-4636190af475", price: "₹38,500" },
    { img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853", price: "₹55,000" },
    { img: "https://images.unsplash.com/photo-1518770660439-4636190af475", price: "₹48,000" },
  ],
  "Printers / scanners": [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹12,500" },
    { img: "https://images.unsplash.com/photo-1593642532400-2682810df593", price: "₹15,800" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹18,000" },
    { img: "https://images.unsplash.com/photo-1593642532400-2682810df593", price: "₹14,200" },
  ],
  "Biometric attendance machine": [
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹4,500" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹5,200" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹6,000" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹4,900" },
  ],
  "Visitor register": [
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹180" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹220" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹250" },
    { img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2", price: "₹300" },
  ],
  "Cashbook & voucher books": [
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹350" },
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹420" },
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹390" },
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹480" },
  ],
  "Stationery items": [
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹250" },
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹180" },
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹300" },
    { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", price: "₹220" },
  ],
  "UPS / inverter": [
    { img: "https://images.unsplash.com/photo-1625157141234-8c9e5b8e4b43", price: "₹18,000" },
    { img: "https://images.unsplash.com/photo-1625157141234-8c9e5b8e4b43", price: "₹22,000" },
    { img: "https://images.unsplash.com/photo-1625157141234-8c9e5b8e4b43", price: "₹25,000" },
    { img: "https://images.unsplash.com/photo-1625157141234-8c9e5b8e4b43", price: "₹20,500" },
  ],
};

export const digitalInfrastructureProducts = {
  "Wi-Fi router": [
    { img: "https://images.unsplash.com/photo-1580894894513-6c7a47b3f6b3", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1580894894513-6c7a47b3f6b3", price: "₹4,000" },
    { img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7", price: "₹3,800" },
  ],
  "LAN setup": [
    { img: "https://images.unsplash.com/photo-1581091870622-6c7a47b3f6b3", price: "₹8,000" },
    { img: "https://images.unsplash.com/photo-1581091870622-6c7a47b3f6b3", price: "₹10,500" },
    { img: "https://images.unsplash.com/photo-1581091870622-6c7a47b3f6b3", price: "₹12,000" },
    { img: "https://images.unsplash.com/photo-1581091870622-6c7a47b3f6b3", price: "₹9,800" },
  ],
  "CCTV cameras": [
    { img: "https://images.unsplash.com/photo-1581090464777-8aabf0a44d8c", price: "₹2,200" },
    { img: "https://images.unsplash.com/photo-1581090464777-8aabf0a44d8c", price: "₹3,000" },
    { img: "https://images.unsplash.com/photo-1581090464777-8aabf0a44d8c", price: "₹3,800" },
    { img: "https://images.unsplash.com/photo-1581090464777-8aabf0a44d8c", price: "₹2,900" },
  ],
  "Computer lab systems": [
    { img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8", price: "₹45,000" },
    { img: "https://images.unsplash.com/photo-1518770660439-4636190af475", price: "₹38,000" },
    { img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853", price: "₹52,000" },
    { img: "https://images.unsplash.com/photo-1518770660439-4636190af475", price: "₹48,000" },
  ],
  "Server / cloud storage": [
    { img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31", price: "₹1,20,000" },
    { img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31", price: "₹95,000" },
    { img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31", price: "₹1,50,000" },
    { img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31", price: "₹1,10,000" },
  ],
  "Smart class equipment": [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹55,000" },
    { img: "https://images.unsplash.com/photo-1593784991095-a205069470b6", price: "₹62,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹70,000" },
    { img: "https://images.unsplash.com/photo-1593784991095-a205069470b6", price: "₹58,000" },
  ],
  "School ERP (MAPEDU)": [
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹15,000 / yr" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹18,000 / yr" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹20,000 / yr" },
    { img: "https://images.unsplash.com/photo-1581093588401-22d8a2d8a5d4", price: "₹25,000 / yr" },
  ],
  "ID card printer": [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹28,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹32,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹35,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹40,000" },
  ],
  "Payment gateway setup (MAPEDU Wallet / Razorpay)": [
    { img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d", price: "₹7,500" },
    { img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d", price: "₹10,000" },
    { img: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d", price: "₹12,000" },
  ],
};

export const libraryProducts = {
  "Book racks": [
    { img: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f", price: "₹8,000" },
    { img: "https://images.unsplash.com/photo-1519681393784-d120267933ba", price: "₹10,500" },
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹12,000" },
    { img: "https://images.unsplash.com/photo-1516979187457-637abb4f9353", price: "₹9,200" },
  ],
  "Library table & chairs": [
    { img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511", price: "₹18,000" },
    { img: "https://images.unsplash.com/photo-1493666438817-866a91353ca9", price: "₹22,000" },
    { img: "https://images.unsplash.com/photo-1549187774-b4e9b0445b06", price: "₹25,000" },
    { img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511", price: "₹20,500" },
  ],
  "Library management register / software": [
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹2,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹8,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹12,000" },
  ],
  "Storybooks, textbooks, references": [
    { img: "https://images.unsplash.com/photo-1512820790803-83ca734da794", price: "₹500" },
    { img: "https://images.unsplash.com/photo-1528207776546-365bb710ee93", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1507842217343-583bb7270b66", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1516979187457-637abb4f9353", price: "₹3,000" },
  ],
  "Barcode scanner (optional)": [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹3,500" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹4,200" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹6,500" },
  ],
};

export const scienceLabProducts = {
  Physics: [
    { img: "https://images.unsplash.com/photo-1581090700227-1e37b190418e", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1581090700227-1e37b190418e", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1581090700227-1e37b190418e", price: "₹4,000" },
    { img: "https://images.unsplash.com/photo-1581090700227-1e37b190418e", price: "₹5,500" },
  ],
  Chemistry: [
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹3,000" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹4,500" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹6,000" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹8,000" },
  ],
  Biology: [
    { img: "https://images.unsplash.com/photo-1581093588401-12d5bfa3b0c4", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1581093588401-12d5bfa3b0c4", price: "₹7,500" },
    { img: "https://images.unsplash.com/photo-1581093588401-12d5bfa3b0c4", price: "₹9,000" },
    { img: "https://images.unsplash.com/photo-1581093588401-12d5bfa3b0c4", price: "₹12,000" },
  ],
};

export const sportsEquipmentProducts = {
  "Cricket kit": [
    { img: "https://images.unsplash.com/photo-1593766788308-318e3a57d1a1", price: "₹3,500" },
    { img: "https://images.unsplash.com/photo-1603636969840-87e13c84a7d5", price: "₹4,200" },
    { img: "https://images.unsplash.com/photo-1593766788308-318e3a57d1a1", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1593766788308-318e3a57d1a1", price: "₹6,500" },
  ],
  Football: [
    { img: "https://images.unsplash.com/photo-1546519638-68e109498ffc", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1600679472829-3044539ce8c3", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1546519638-68e109498ffc", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1546519638-68e109498ffc", price: "₹2,000" },
  ],
  "Volleyball & net": [
    { img: "https://images.unsplash.com/photo-1609861517207-358e6b70e0fd", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1609861517207-358e6b70e0fd", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1609861517207-358e6b70e0fd", price: "₹4,000" },
    { img: "https://images.unsplash.com/photo-1609861517207-358e6b70e0fd", price: "₹5,000" },
  ],
  "Kho-Kho poles": [
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹2,200" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹2,800" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹3,500" },
  ],
  "Badminton rackets & shuttle": [
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹2,200" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹3,000" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹4,500" },
  ],
  "Carrom board": [
    { img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d", price: "₹3,500" },
    { img: "https://images.unsplash.com/photo-1627328715728-7bcc1b5db87d", price: "₹4,000" },
  ],
  Chess: [
    { img: "https://images.unsplash.com/photo-1580541832626-2a7131ee809f", price: "₹800" },
    { img: "https://images.unsplash.com/photo-1580541832626-2a7131ee809f", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1580541832626-2a7131ee809f", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1580541832626-2a7131ee809f", price: "₹2,500" },
  ],
  "Track markers": [
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹900" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1599058917212-d750089bc07c", price: "₹2,200" },
  ],
  "First aid kit": [
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹2,000" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹3,000" },
  ],
};

export const safetyComplianceProducts = {
  "Fire extinguishers": [
    { img: "https://images.unsplash.com/photo-1581579186898-3a6a5c8b97c0", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1581579186898-3a6a5c8b97c0", price: "₹3,200" },
    { img: "https://images.unsplash.com/photo-1581579186898-3a6a5c8b97c0", price: "₹4,500" },
    { img: "https://images.unsplash.com/photo-1581579186898-3a6a5c8b97c0", price: "₹6,000" },
  ],
  "First aid box": [
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1583947215259-38e31be8751f", price: "₹2,500" },
  ],
  "Emergency exit signs": [
    { img: "https://images.unsplash.com/photo-1590487988251-7e3f1d2df3c1", price: "₹800" },
    { img: "https://images.unsplash.com/photo-1590487988251-7e3f1d2df3c1", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1590487988251-7e3f1d2df3c1", price: "₹1,800" },
    { img: "https://images.unsplash.com/photo-1590487988251-7e3f1d2df3c1", price: "₹2,500" },
  ],
  CCTV: [
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹2,800" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹4,000" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹6,500" },
    { img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04", price: "₹9,000" },
  ],
  "Visitor management system": [
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹5,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹8,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹12,000" },
    { img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71", price: "₹18,000" },
  ],
  "Student ID cards": [
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹500" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹800" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹1,200" },
    { img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b", price: "₹2,000" },
  ],
  "Transport compliance documents": [
    { img: "https://images.unsplash.com/photo-1554224154-22dec7ec8818", price: "₹1,000" },
    { img: "https://images.unsplash.com/photo-1554224154-22dec7ec8818", price: "₹1,500" },
    { img: "https://images.unsplash.com/photo-1554224154-22dec7ec8818", price: "₹2,500" },
    { img: "https://images.unsplash.com/photo-1554224154-22dec7ec8818", price: "₹4,000" },
  ],
};

export const marketingCategoryProducts = {
  "Classroom Essentials": classroomProducts,
  "Office & Administration Items": officeAdminProducts,
  "Digital Infrastructure": digitalInfrastructureProducts,
  "Library Items": libraryProducts,
  "Science Lab Items": scienceLabProducts,
  "Sports Equipment": sportsEquipmentProducts,
  "Safety & Compliance": safetyComplianceProducts,
};
